import { runInAction } from "mobx";
import { StateCallback, sessionStore, watchStoreProperty } from "csi/state/rootStore";

// TODO: Transition to using sessionStore directly rather than state.get/set

function get(key: string): any {
	return sessionStore[key];
}

function set(key: string, value: any): void {
	runInAction(() => {
		sessionStore[key] = value;
	});
}

function watch(key: string, callback: StateCallback): object {
	return watchStoreProperty(sessionStore, key, callback);
}

export = {
	get,
	set,
	watch,
};